import {
  getMyDetail,
  saveRealtimeMonitorSubscribe,
} from '@/api/realtimemonitorsubscribeserv'

export default {
  state: {
    state_RealtimeMonitorSubscribe_GetMyDetailResult: null,
    state_RealtimeMonitorSubscribe_SaveRealtimeMonitorSubscribeResult: null,
  },
  mutations: {
    SET_REALTIMEMONITORSUBSCRIBE_GETMYDETAIL_RESULT: (state, rst) => {
      state.state_RealtimeMonitorSubscribe_GetMyDetailResult = rst;
    },
    SET_REALTIMEMONITORSUBSCRIBE_SAVEREALTIMEMONITORSUBSCRIBE_RESULT: (state, rst) => {
      state.state_RealtimeMonitorSubscribe_SaveRealtimeMonitorSubscribeResult = rst;
    },
  },
  actions: {
    RealtimeMonitorSubscribeServ_GetMyDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REALTIMEMONITORSUBSCRIBE_GETMYDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REALTIMEMONITORSUBSCRIBE_GETMYDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RealtimeMonitorSubscribeServ_SaveRealtimeMonitorSubscribe({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        saveRealtimeMonitorSubscribe(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REALTIMEMONITORSUBSCRIBE_SAVEREALTIMEMONITORSUBSCRIBE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REALTIMEMONITORSUBSCRIBE_SAVEREALTIMEMONITORSUBSCRIBE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RealtimeMonitorSubscribe_GetMyDetailResult: state => {
      return state.state_RealtimeMonitorSubscribe_GetMyDetailResult;
    },
    get_RealtimeMonitorSubscribe_SaveRealtimeMonitorSubscribeResult: state => {
      return state.state_RealtimeMonitorSubscribe_SaveRealtimeMonitorSubscribeResult;
    },
  }
}